import {hideLogoutInterstitial, showLogoutInterstitial} from "./components-global";

(function () {
  var initMultipass = function (res) {
    return function () {
      let data = {
        id: res.UID,
        email: res.profile.email,
        firstName: res.profile.firstName,
        lastName: res.profile.lastName,
        returnMultipassToken: true,
      }

      const url = window.location.href
      const urlObj = new URL(url)
      const returnUrl = urlObj.searchParams.get('return_url')
      const decodedReturnUrl = decodeURIComponent(returnUrl)
      if (decodedReturnUrl !== null && urlObj.hash) window.loginReturnTo = returnUrl + urlObj.hash
      if (window.loginReturnTo) data.returnTo = window.loginReturnTo

      $.ajax({
        method: 'POST',
        url: window.akc.services.multipassUrl,
        contentType: 'application/json',
        data: JSON.stringify(data),
        success: function (data) {
          window.localStorage.setItem('multipassToken', data.token)
          window.localStorage.removeItem('customerAccessToken')
          window.localStorage.removeItem('customerAccessTokenExpiresAt')
          window.location.href = data.authUrl
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.error(textStatus, errorThrown)
        }
      })
    }
  }

  const initRecaptcha = (action, callback = null) => {
    return new Promise((resolve, reject) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(window.akc.recaptcha.siteKey, { action })
        .then(token => {
          if (callback) {
            callback(token)
              .then(result => {
                resolve(result);
              })
              .catch(error => {
                reject(error);
              });
          }
        })
        .catch(error => {
          reject(error);
        });
      })
    })
  }

  const verify = async (token) => {
    try {
      let isBot = false;
      const response = await fetch(window.akc.services.recaptchaUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ token })
      });
      const data = await response.json();

      if (data.siteVerifyResponse.score <= window.akc.recaptcha.threshold) {
        isBot = true;
      }
      return isBot;
    } catch (error) {
      throw error;
    }
  };

  const checkBot = async (event) => {
    let action

    if (event.form === "gigya-register-form") {
      action = 'sign_up'
    } else if (event.form === "gigya-login-form") {
      action = 'sign_in'
    }

    let isBot = await initRecaptcha(action, verify)

    let errors = {
      sign_in: {"form":"Bot detected: prevent sign in"},
      sign_up: {"form":"Bot detected: prevent sign up"},
    }
    if (isBot) return errors[action];
  }

  gigya.accounts.addEventHandlers({
    onLogin: function (res) {
      var multipass = initMultipass(res)

      multipass()
    },
    onLogout: function () {
      window.location.href = window.akc.routes.accountLogoutUrl
    }
  })

  // Global session validator - runs on all pages
  const validateGlobalSession = () => {
    gigya.accounts.getAccountInfo({
      callback: (res) => {
        if (!res.UID && window.localStorage.getItem('multipassToken')) {
          // Session expired but token still in localStorage - force logout
          console.warn('Gigya session expired, forcing logout...')
          window.akc.getLogoutScreenset()
        }
      }
    })
  }

  // Check every 5 minutes if user is still logged in
  const sessionCheckInterval = setInterval(validateGlobalSession, 5 * 60 * 1000)

  // Also validate on page visibility change (when tab returns to focus)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      validateGlobalSession()
    }
  })

  window.akc.getRegisterScreenset = function (options) {
    window.loginReturnTo = options?.returnTo || window.location.href

    window.gigya.accounts.showScreenSet({
      screenSet: 'Login-web-2',
      startScreen: 'gigya-register-screen',
      mobileScreenSet: 'Login-web-2',
      onBeforeValidation: (e) => checkBot(e)
    })
  }

  window.akc.getLoginScreenset = function (options) {
    window.loginReturnTo = options?.returnTo || window.location.href

    window.gigya.accounts.showScreenSet({
      screenSet: 'Login-web-2',
      startScreen: 'gigya-login-screen',
      mobileScreenSet: 'Login-web-2',
      onBeforeValidation: (e) => checkBot(e)
    })
    if (window.location.pathname === window.akc.routes.cartUrl){
      window.loginReturnTo = window.akc.routes.cartUrl
    }
  }

  window.akc.getLogoutScreenset = function () {
    window.localStorage.removeItem('multipassToken')
    window.localStorage.removeItem('customerAccessToken')
    window.localStorage.removeItem('customerAccessTokenExpiresAt')

    let currentPageURL = window.location.href
    let redirectToCurrentPage = (response) => {
      window.localStorage.setItem('logoutResponse', JSON.stringify(response));
      showLogoutInterstitial();
      if (response.errorCode == 0) {
        setTimeout(() => {
          window.location.href = currentPageURL;
          hideLogoutInterstitial();
        }, 1000); // 1000ms delay prevent redirect before logout fully completes
      } else {
        alert('Error :' + response.errorMessage);
      }
    }

    window.gigya.accounts.logout({callback: redirectToCurrentPage})
  }
})()
